var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useQuery } from "react-query";
import { ResourceService } from "../../../services/resource/resource.service";
export var useResources = function (resourceIds) {
    var idsSorted = __spreadArray([], resourceIds, true).sort(function (a, b) { return a === null || a === void 0 ? void 0 : a.localeCompare(b); });
    var query = useQuery(['allResources', idsSorted], function () { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!idsSorted.length)
                        return [2 /*return*/, []];
                    return [4 /*yield*/, ResourceService.getAllResources({
                            id: idsSorted,
                            limit: {
                                offset: 0,
                                limit: 1000,
                                sort: [{ field: "name", direction: "ASC" }]
                            }
                        })];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response.content || []];
            }
        });
    }); });
    return query.data || [];
};
export var useResource = function (resourceId) {
    var _a;
    var query = useQuery(['allResources', [resourceId]], function () { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!resourceId)
                        return [2 /*return*/, []];
                    return [4 /*yield*/, ResourceService.getAllResources({
                            id: [resourceId],
                            limit: {
                                offset: 0,
                                limit: 1,
                                sort: [{ field: "name", direction: "ASC" }]
                            }
                        })];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response.content || []];
            }
        });
    }); });
    return (_a = query.data) === null || _a === void 0 ? void 0 : _a[0];
};
export var useAllResources = function () {
    var query = useQuery('allResourcesForLookup', function () { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, ResourceService.getAllResources({
                        limit: {
                            offset: 0,
                            limit: 1000,
                            sort: [{ field: "name", direction: "ASC" }]
                        }
                    })];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response.content || []];
            }
        });
    }); });
    return query.data || [];
};
export var useResourceFilterOptions = function () {
    return useQuery('resourceFilterOptions', ResourceService.getFilterOptions, {
        // 10 minutes
        staleTime: 10 * 60 * 1000
    });
};
